import gql from "graphql-tag";
import { COMPANY_FRAGMENT } from "./fragments";

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      ...CompanyInfo
    }
  }
  ${COMPANY_FRAGMENT}
`;
